import { withInstall } from '../../utils'

import _DateButtonGroup from './src/date-button-group.vue'

export const SdDateButtonGroup = withInstall(_DateButtonGroup)
export default SdDateButtonGroup

export * from './src/date-button-group'
